if(!customElements.get('collection-actions-view')) {
  customElements.define('collection-actions-view', class ProductGrid extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');

      if (this.buttons.length === 0) {
        return;
      }

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.buttons.forEach(button => {
        button.addEventListener('click', () => {
          const buttontype = button.getAttribute('data-type');
          const productWrapper = document.querySelector('ul#product-grid');
          let currentUrl = new URL(window.location.href);

          this.setupButtonOpacity();

          if(buttontype == 'grid') {
            productWrapper.className = "";
            productWrapper.classList.add('product-grid', 'grid', 'grid-2-col', 'grid-3-col-tablet', 'grid-compact', 'grid-5-col-desktop');

            // currentUrl.searchParams.set('view_type', 'grid'); 

          } else if (buttontype == 'list') {
            productWrapper.className = "";
            productWrapper.classList.add('product-list');

            // currentUrl.searchParams.set('view_type', 'list')

          } 
          
          // window.history.pushState({}, '', currentUrl);
          button.style.opacity = 1;
        })
      })
    }

    setupButtonOpacity() {
      this.buttons.forEach(button => {
        button.style.opacity = '0.5';
      })
    }
  })
}